import { render, staticRenderFns } from "./ItemBigImg.vue?vue&type=template&id=6f497d05&scoped=true&"
import script from "./ItemBigImg.vue?vue&type=script&lang=js&"
export * from "./ItemBigImg.vue?vue&type=script&lang=js&"
import style0 from "./ItemBigImg.vue?vue&type=style&index=0&id=6f497d05&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f497d05",
  null
  
)

export default component.exports